let CacheMaster = null;

// Ensure Aerospike is only used on the server
if (typeof window === "undefined") {
  const Aerospike = require("aerospike");
  const zlib = require("zlib");
  let client;
  // Constants for namespace and set
  const NAMESPACE = process?.env?.NEXT_PUBLIC_ENV === "development" ? "flights" : "seo"; // Replace with your desired namespace
  const SET = "flights_seo";
  const AEROSPIKETIMEOUT = 30000; // 30 seconds

  async function createAerospikeClient() {
    const config =
      process?.env?.NEXT_PUBLIC_ENV === "development"
        ? {
            hosts: [{ addr: "10.213.57.169", port: 3000 }],
            policies: {
              read: new Aerospike.ReadPolicy({ timeout: AEROSPIKETIMEOUT }),
              write: new Aerospike.WritePolicy({ timeout: AEROSPIKETIMEOUT }),
            },
          }
        : {
            hosts: [
              { addr: "aerospike-common-pwa-1.mmt.mmt", port: 3000 },
              { addr: "aerospike-common-pwa-2.mmt.mmt", port: 3000 },
              { addr: "aerospike-common-pwa-3.mmt.mmt", port: 3000 },
            ], // Adjust your Aerospike host
            policies: {
              read: new Aerospike.ReadPolicy({ timeout: AEROSPIKETIMEOUT }),
              write: new Aerospike.WritePolicy({ timeout: AEROSPIKETIMEOUT }),
            },
          };

    if (!client) {
      try {
        client = await Aerospike.connect(config);
        console.log("Connected to Aerospike");
      } catch (err) {
        console.error("Aerospike Connection Error:", err);
      }
    }
    return client;
  }

  async function getAerospikeClient() {
    if (!client) {
      client = await createAerospikeClient();
    }
    return client;
  }

  async function truncate() {
    const aerospikeClient = await getAerospikeClient();
    aerospikeClient.truncate(null, NAMESPACE, SET, 0);
  }

  async function setCache(key, resp, time) {
    const aerospikeClient = await getAerospikeClient();
    const aerospikeKey = new Aerospike.Key(NAMESPACE, SET, key);
    try {
      const record = { SEO_RESPONSE: zlib.gzipSync(JSON.stringify(resp)), version: 2 }; // Version 2 is compressed data
      await aerospikeClient.put(aerospikeKey, record, { ttl: time });
      console.log(`Data cached under key: ${key} with TTL: ${time}s`);
    } catch (err) {
      console.error("Error setting cache in Aerospike:", err);
      throw err;
    }
  }

  async function getCache(key) {
    const aerospikeClient = await getAerospikeClient();
    const aerospikeKey = new Aerospike.Key(NAMESPACE, SET, key);

    try {
      const record = await aerospikeClient.get(aerospikeKey);
      const value = record.bins.SEO_RESPONSE;
      let result = JSON.parse(zlib.gunzipSync(value).toString());
      console.log(`Cache found under key: ${key}`, JSON.stringify(result));
      return result;
    } catch (err) {
      if (err.code === Aerospike.status.AEROSPIKE_ERR_RECORD_NOT_FOUND) {
        console.log(`Key "${key}" not found in cache`);
        return null;
      }
      return null;
    }
  }

  async function deleteKey(key) {
    const aerospikeClient = await getAerospikeClient();
    const aerospikeKey = new Aerospike.Key(NAMESPACE, SET, key);
    try {
      await aerospikeClient.remove(aerospikeKey);
      console.log(`Deleted cache under key: ${key}`);
    } catch (err) {
      console.error("Error deleting cache from Aerospike:", err);
      throw err;
    }
  }

  CacheMaster = {
    getCache,
    setCache,
    getAerospikeClient,
    truncate,
    deleteKey,
  };
} else {
  // No-op functions for client-side to avoid runtime errors
  CacheMaster = {
    getCache: async () => null,
    setCache: async () => null,
    getAerospikeClient: async () => null,
    truncate: async () => null,
    deleteKey: async () => null,
  };
}

export default CacheMaster;
